import { AccordionContent } from "@/core/types/types";
import { AccordionDetails as MuiAccordionDetails } from "@mui/material";
import { Box } from "@mui/system";
import BoardingPassAccordion from "./content/BoardingPassAccordion";
import FlightProblemAccordion from "./content/FlightProblemAccordion";
import CompensationInfoAccordion from "./content/CompensationInfoAccordion";
import { Typography } from "@mui/material";

interface AccordionDetailsProps {
  contentType: AccordionContent | undefined;
}

const AccordionDetails = ({ contentType }: AccordionDetailsProps) => {
  const AccordionDetailsContent = () => {
    switch (contentType) {
      case AccordionContent.FlightNumber:
        return <BoardingPassAccordion />;
      case AccordionContent.FlightProblems:
        return <FlightProblemAccordion />;
      case AccordionContent.CompensationInfo:
        return <CompensationInfoAccordion />;
      default:
        return <Typography>Content is not specified</Typography>;
    }
  };

  return (
    <MuiAccordionDetails>
      <Box>
        <AccordionDetailsContent />
      </Box>
    </MuiAccordionDetails>
  );
};

export default AccordionDetails;
